<!-- 投标 -->
<template>
    <div>
      <el-form label-width="200px">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <h2>会员报价列表</h2>
            </template>
            
            <el-table v-bind:data="quoteList" @row-click="onRowClick">
              <el-table-column label="报价渠道" prop="webType" width="100">
              </el-table-column>
              
              <el-table-column label="报价时间" prop="createTime" width="160">
              </el-table-column>
              
              <el-table-column label="报价人id" prop="bidUserId">
              </el-table-column>   
              <el-table-column label="报价人" prop="bidNickName">
              </el-table-column >
              <el-table-column label="报价" prop="finalPrice" sortable>
              </el-table-column>
              
              <el-table-column label="新车价" prop="newCarPrice" sortable>
              </el-table-column>
              <el-table-column label="二手车价" prop="usedCarPrice" sortable>
              </el-table-column>

              <el-table-column label="维修费" prop="maintenanceCost" sortable>
              </el-table-column>
              
                <el-table-column label="客户利润" prop="profit" sortable>
                </el-table-column>

                <el-table-column label="公司利润" prop="profitCompany" sortable>
                </el-table-column>
                <!--
                <el-table-column label="拖车费" prop="towingFee" sortable>
                </el-table-column>
                -->
              <el-table-column label="其他费用" prop="otherFee" sortable>
              </el-table-column>
              
              

              <el-table-column label="理论价格"  prop="" sortable>
                <template v-slot="slotProps">
                    {{slotProps.row.usedCarPrice
                    -slotProps.row.maintenanceCost
                    -slotProps.row.profit
                    -slotProps.row.profitCompany
                    -slotProps.row.otherFee
                    -slotProps.row.towingFee}}
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <!-- 报价区域 -->
          <el-collapse-item name="2">
            <template slot="title">
              <h2>提交报价</h2>
            </template>
            <el-row>
                <el-col :span="6">
                     
                    <el-form-item label="报价人Id">
                        
                        <el-input v-model="quoteForm.bidUserId">
                            <el-button slot="append" type="primary" @click="handleGetUserDetail">获取本人ID</el-button>
                        </el-input>
                       
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="报价人">
                    <el-input v-model="quoteForm.bidNickName">
                    </el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-tooltip class="item" effect="dark" content="用户可以看到的价格" placement="top-start">
                    <el-form-item label="最终报价(A)">
                    <el-input v-model="quoteForm.submitPrice">
                    </el-input>
                    <el-button type="primary" @click="handleSyncSubmitPrice">同步报价</el-button>
                    </el-form-item>
                    </el-tooltip>
                </el-col>
                <el-col :span="6">
                    <el-tooltip class="item" effect="dark" content="管理员看到的价格" placement="top-start">
                    <el-form-item label="最终报价(B)">
                    <el-input v-model="quoteForm.submitPriceIn">
                    </el-input>
                    </el-form-item>
                    </el-tooltip>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="备注">
                    <el-input type="textarea" v-model="quoteForm.remark">
                    </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
    
            <el-row>
              <el-col :span="6">
                <el-form-item >
                  <el-button type="primary" :disabled="blnSubmit" @click="handleSubmit">
                   提交报价 (B)
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          
          <!-- 时间 -->
          <el-collapse-item name="3">
            <template slot="title">
              <h2 style="color:red">时间</h2>
            </template>

            <el-row>
                    <el-col :span="6">
                        <el-form-item label="询价时间:">
                            <el-date-picker
                                v-model="dataForm.bidStartTime"
                                value-format="yyyy-MM-dd hh:mm:ss"
                                placeholder="请选择询价时间"
                                :disabled="true"
                                type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="逾期时间:">
                            <el-date-picker
                            v-model="dataForm.bidEndTime"
                            placeholder="请选择逾期时间"
                            value-format="yyyy-MM-dd hh:mm:ss"
                            :disabled="true"
                            type="date">
                            </el-date-picker>
                        </el-form-item>  
                    </el-col> 
            </el-row>
          </el-collapse-item>
          <!-- 基础信息 -->
          <el-collapse-item name="4">
            <template slot="title">
              <h2 style="color:red">基础信息</h2>
            </template>
            <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆编号:">
                            <el-input class="text-disabled" v-model="dataForm.vehicleSn" :disabled="true" placeholder="请输入车辆编号" >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="报案号">
                            <el-input class="text-disabled" v-model="dataForm.caseSn" :disabled="true" placeholder="请输入报案号">
                            </el-input>
                        </el-form-item>   
                    </el-col>

                </el-row>

                <!--  -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="保险公司">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.insureCompany" placeholder="请输入保险公司">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="分公司">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.insureFiliale" placeholder="请输入保险分公司">

                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="分支机构">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.insureBranch" placeholder="请输入保险分机构">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--  -->
                <el-row>
                    
                    <el-col :span="6">
                        <el-form-item label="登记日期">
                           
                            <el-date-picker
                            :disabled="true"
                            class="text-disabled"
                            v-model="dataForm.factory.registerDate"
                            placeholder="请选择登记日期"
                            value-format="yyyy-MM-dd"
                            type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车架号">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.vin" placeholder="请输入车架号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车牌号">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.current.plateNo" placeholder="请输入车牌号">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    
                    
                    <el-col :span="6">
                        <el-form-item label="发动机号">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.engineNo" placeholder="请输入发动机号"> 
                            </el-input>
                        </el-form-item>   
                    </el-col>
                
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆型号(品牌型号)">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.vehicleModel" placeholder="请输入车辆车型标志">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车型">
                            <el-input class="text-disabled css-vehicle-modle " :disabled="true" v-model="dataForm.factory.vehicleTradeName" placeholder="请输入车辆车型传播名">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发票金额" >
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.invoiceValue">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                <!--  -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车辆性质">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.current.passengerCommercial" placeholder="车辆商用乘用">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车辆停放地">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.vehicleParkingArea" placeholder="请输入车辆当前停放地" clearable>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="所有人性质(车辆归属)">
                            <el-input  class="text-disabled" :disabled="true" v-model="dataForm.current.ownership" placeholder="请输入车辆的所属性质(公司/个人)">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!--  -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="是否二手车">
                            <el-select class="text-disabled" :disabled="true" v-model="dataForm.current.blnTransfer" placeholder="是否二手车" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车辆类型">
                            <el-input >
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="发证日期">
                           
                            <el-date-picker
                                class="text-disabled"
                                :disabled="true"
                                v-model="dataForm.current.issueDate"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择询价时间"
                                type="date">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="公里数">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.current.vehicleKim">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="变速箱类型">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.gearboxType">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="排量">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.factory.vehicleDisplacement">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :span="6">
                        <el-form-item label="乘用商用">
                            <el-input v-model="dataForm.current.passengerCommercial">
                            </el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row> 

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="保险金额">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insureAmount">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="估损金额">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.estimatedAmount">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车损原因">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="车辆种类(事故类型)">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="出险日期">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="报价有效期">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="大票金额">
                            <el-input>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="实际价值(全损金额)">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.current.practicalValue">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="定损员姓名">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.surveyorName">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="定损员电话">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.insurance.surveyorPhone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="发动机是否完好">
                            <el-input class="text-disabled" :disabled="true" v-model="dataForm.damage.engineGood" placeholder="发动机是否完好">
                            </el-input>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="事故备注">
                            <el-input :disabled="true" class="text-disabled" type="textarea" v-model="dataForm.vehicleAccidentRemark" placeholder="发动机备注" clearable>
                            </el-input>
                        </el-form-item>
                        
                    </el-col>

                    <el-col :span="6">
                        <p v-html="translateHtml(dataForm.vehicleAccidentRemark)"></p>
                    </el-col>

                    <el-col :span="6">
                        <el-tag  effect="dark" type="danger" v-if="dataForm.offeringSecond=='Y'">二次询价车辆</el-tag>
                    </el-col>
                </el-row>
          </el-collapse-item>
            <!-- 手续信息 -->
            <el-collapse-item  name="5">
                <template slot="title">
                    <h2 style="color:red">手续信息</h2>
                </template>
                <el-row>
                    <el-col :span="6" >
                        <el-form-item label="是否抵押">
                            <el-select class="text-disabled" :disabled="true" v-model="dataForm.procedure.mortgage" placeholder="是否抵押" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                            
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="购置税本">
                            <el-select :disabled="true" v-model="dataForm.procedure.purchaseTax" placeholder="是否有购置税本" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" >
                        <el-form-item label="是否有贷款">
                            <el-select :disabled="true" v-model="dataForm.procedure.loan" placeholder="是否有贷款" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                        
                    </el-col>

                    
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="组织机构代码证">
                            <el-select  :disabled="true" v-model="dataForm.procedure.organizationCodeCertificate" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="权益转让书">
                                <el-select :disabled="true" v-model="dataForm.procedure.subrogationReceipt" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="委托协议">
                                <!-- <el-select  clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select> -->
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="破案证书">
                                <!-- <el-select  placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select> -->
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="车主身份证复印件">
                                <el-select :disabled="true" class="text-disabled" v-model="dataForm.procedure.idCardCopy" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    :disabled="true"
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="钥匙">
                                <el-select :disabled="true" v-model="dataForm.procedure.vehicleKey" placeholder="是否有组织机构代码证" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>


                    <el-col :span="6">
                        <el-form-item label="车牌">
                            
                                <el-select :disabled="true" v-model="dataForm.procedure.licencePlate" placeholder="是否有车牌" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="行驶证">
                            <el-select :disabled="true" v-model="dataForm.procedure.vehicleLicense" placeholder="是否有车牌" clearable>
                                <el-option 
                                    :disabled="true"
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="登记证书">
                            <el-select :disabled="true" v-model="dataForm.procedure.registrationCertificate" placeholder="是否有车牌" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-collapse-item>
             <!-- 二次报价原因 -->
             <el-collapse-item name="6">
                <template slot="title">
                    <h2 style="color:red">二次报价原因</h2>
                </template>
                <el-row>
                    <el-input :disabled="true"  class="text-disabled" type="textarea">
                    </el-input>
                </el-row>
            </el-collapse-item>


            <el-collapse-item title="二次报价附件" name="7">
                <template slot="title">
                    <h2 style="color:red">二次报价附件</h2>
                </template>
                <el-row>
                    <el-input :disabled="true" type="textarea">
                    </el-input>
                </el-row>
            </el-collapse-item>

            <!--出险信息  -->
            <el-collapse-item  name="8">
               
               <template slot="title">
                   <h2 style="color:red">出险信息</h2>
               </template>
               <el-row>
                   <el-col :span="6">
                       <el-form-item label="责任认定">
                           <el-input class="text-disabled" :disabled="true" v-model="dataForm.damage.responsibility"  placeholder="请输入责任认定" >
                           </el-input>
                       </el-form-item>
                   </el-col>

                   <el-col :span="6">
                       <el-form-item label="车身电脑是否完整">
                           <el-select  :disabled="true" class="text-disabled" v-model="dataForm.damage.vehicleEcu" placeholder="请选择车身电脑是否完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>

                       
                   </el-col>
                   <el-col :span="6">
                       <el-form-item label="发动机电脑是否完好">
                           <el-select v-model="dataForm.damage.vehicleEcu"  :disabled="true" class="text-disabled" placeholder="请选择发动机电脑是否完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                   </el-col>

                   <el-col :span="6">
                       <el-form-item label="发动机是否完好">
                           <el-select v-model="dataForm.damage.engineGood"  :disabled="true" class="text-disabled" placeholder="请选择发动机是否完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                       
                   </el-col>

                   <el-col :span="6">    
                       <el-form-item label="是否脱审">
                           <el-select v-model="dataForm.damage.delisting"  :disabled="true" class="text-disabled" placeholder="请选择是否脱审" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                       
                   </el-col>

                   <el-col :span="6">
                       <el-form-item label="人伤情况">
       
                           <el-input v-model="dataForm.damage.casualties"  :disabled="true" class="text-disabled" placeholder="请输入人伤情况" >
                           </el-input>

                       </el-form-item>
                       
                   </el-col>
                   <el-col :span="6">
                       <el-form-item label="天窗是否完好">
                           <el-select v-model="dataForm.damage.skylightGood"  :disabled="true" class="text-disabled" placeholder="请选择天窗是否完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                       
                   </el-col>
                   <el-col :span="6">
                       <el-form-item label="是否拆解">
                           <el-select  :disabled="true" v-model="dataForm.damage.assemble" class="text-disabled" placeholder="请选择是否拆解" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                   </el-col>

                   

                   

                   <el-col :span="6">
                       <el-form-item label="变速箱完好">
                           
                           <el-select  :disabled="true" v-model="dataForm.damage.gearboxGood" class="text-disabled" placeholder="请选择变速箱完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>

                   </el-col>

                  

                   <el-col :span="6">
                       <el-form-item label="是否二次事故">
                           <el-select  :disabled="true" v-model="dataForm.current.secondaryAccident" class="text-disabled" placeholder="请选择是否二次事故" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                   </el-col>
                   
                   <el-col :span="6">
                       <el-form-item label="车辆大架号完好">
 
                           <el-select  :disabled="true" v-model="dataForm.damage.steelSealNumber" class="text-disabled" placeholder="车辆大架号完好" clearable>
                               <el-option 
                                   v-for="dict in dict.type.sys_yes_no"
                                   :key="dict.value"
                                   :label="dict.label"
                                   :value="dict.value"
                               />
                           </el-select>
                       </el-form-item>
                   </el-col>
               

             
           </el-row>
           </el-collapse-item>
           <!-- 费用信息 -->
           <el-collapse-item name="9">
                <template slot="title">
                    <h2 style="color:red">费用信息(由竞价单位承担)</h2>
                </template>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="停车费">
                            <el-input v-model="dataForm.cost.parkingFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拆检费">
                            <el-input v-model="dataForm.cost.overhaulFee">
                            </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="拖车费">
                            <el-input v-model="dataForm.cost.towingFee">

                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="施救费">
                            <el-input v-model="dataForm.cost.salvageFee">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="其他费用">
                            <el-input v-model="dataForm.cost.otherFee">
                            </el-input> 
                        </el-form-item>
                    </el-col>
                </el-row>   
            </el-collapse-item>
            <!-- 照片 -->
            <el-collapse-item  name="10">
                <template slot="title">
                    <h2 style="color:red">照片</h2>
                </template>
             
                <el-image 
                    style="width: 100px; height: 100px"
                    v-for="urlItem in dataForm.damage.imgUrls" :key="urlItem" :src="urlItem"
                    :preview-src-list="dataForm.damage.imgUrls">
                </el-image> 
                
             

            </el-collapse-item>
            
            <!-- 车300 评估 -->
            <el-collapse-item name="11">
                <template slot="title">
                    <h2 style="color:red">车300评估结果</h2>
                </template>

                <el-tabs  type="card" @tab-click="handleEvaluateTabClick" >
                    <el-tab-pane v-for="tab in dataForm.evaluate" :key="tab.modelId	" :label="tab.modelName" :name="tab.modelName">
                        <!-- <component :is="tab.component" v-bind="tab.props"></component> -->
                        <el-descriptions border>
                            <el-descriptions-item label="车型">
                                {{tab.modelName}}
                            </el-descriptions-item>
                            <el-descriptions-item label="品牌名">
                                {{tab.brandName	}}
                            </el-descriptions-item>
                            <el-descriptions-item label="系列名">
                                {{tab.seriesName}}
                            </el-descriptions-item>

                            <el-descriptions-item label="户籍地">
                                {{tab.cityName}}
                            </el-descriptions-item>

                            <el-descriptions-item label="预估里程">
                                {{tab.mileAge}}
                            </el-descriptions-item>

                            <el-descriptions-item label="新车指导价">
                                {{tab.modelPrice}}
                            </el-descriptions-item>

                            

                        

                            <el-descriptions-item label="出厂日期">
                                {{tab.regDate}}
                            </el-descriptions-item>
                        </el-descriptions>

                        <el-radio-group v-model="radioCondition" @change="handleChangeCondition($event,tab)">
                            <el-radio-button label="normal">车况一般</el-radio-button>
                            <el-radio-button label="good">车况良好</el-radio-button>
                            <el-radio-button label="excelent">车况优秀</el-radio-button>
                        </el-radio-group>

                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerLowBuyPrice"
                                    title="车商最低收车价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerBuyPrice"
                                    title="车商收车价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                :value="evaluatePrice.individualLowSoldPrice"
                                title="个人最低交易价(万元)"
                                ></el-statistic>
                            </el-col>

                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.individualPrice"
                                    title="个人交易价(万元)"
                                ></el-statistic>
                            </el-col>

                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerLowSoldPrice"
                                    title="车商最低零售价(万元)"
                                ></el-statistic>
                            </el-col>
                            
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerPrice"
                                    title="车商零售价(万元)"
                                ></el-statistic>
                            </el-col>
                            <el-col :span="6">
                                <el-statistic
                                    :value="evaluatePrice.dealerHighSoldPrice"
                                    title="车商最高零售价(万元)"
                                ></el-statistic>
                            </el-col>
                        
                        </el-row>
                    </el-tab-pane>
                
                </el-tabs>
            </el-collapse-item>
        </el-collapse> 
      </el-form>

      
    </div>
</template>

<script>
 import {getCase,submitBid} from '@/api/vehicle/case';
 import {getQuoteList}  from '@/api/vehicle/quote';
 import {getUserProfile} from '@/api/system/user';
export default {
    name:'Submit',
  dicts:['sys_yes_no'],
  created(){
    const caseId=this.$route.query.caseid;
  
    if(caseId){
      this.caseId=caseId;
      this.handleGetDetail(caseId);
      this.handleGetQuoteList(caseId);
    }
  },
  beforeRouteEnter(to, from, next) {
        next(vm=>{
            if(to.query.caseid!=vm.caseId){
                vm.caseId=to.query.caseid;
                // 通过caseId 获取详情
                vm.handleGetDetail(vm.caseId);
                vm.handleGetQuoteList(vm.caseId);
            
            }
        });
  },

  data(){
    return{
        radioCondition:'normal',
        evaluatePrice:{},
        activeNames:['0','1','2','3','4','5','6','7','8','9','10','11'],
        caseId:'',
        dataForm:{
            bidStartTime:'',//询价时间(竞价开始)
            bidEndTime:'',//逾期时间(竞价结束)
                
            vehicleSn:'', //车辆编号
            caseSn:'',//报案号
            vehicleParkingArea:'',//车辆停放地

            useCharacter:'',// 车辆使用性质
            vehicleDisplacement:'',//排量
               
            accidentType:'',//事故类型
            insureAmount:'',//保险金额
            actualAmount:'',//实际金额
            estimatedAmount:'',//估损金额
            vehicleAccidentRemark:'',
        //出厂信息
        factory:{
            vin:'',//车架号
            engineNo:'',//发动机号
            registerDate:'',//登记(注册)日期
            vehicleModel:'',//车辆型号(行车证)
            vehicleTradeName:'',//车型型号；传播名
            gearboxType:'',// 变速箱类型
            vehicleDisplacement:'',//汽车排量
            invoiceValue:'',//发票金额
        },

        //当前车辆信息
        current:{
            plateNo:'',//车牌号
            blnTransfer:'',//是否过户
            vehicleKim:'',//公里数
            issueDate:'',//发证日期
            passengerCommercial:'',//乘用商用
            practicalValue:'',//实际价值
            ownership:'',//所有人性质
        },

        //车损信息
        damage:{
            engineGood:'',//发动机是否完好
            vehicleEcu:'',//车身电脑
            engineEcu:'',//发动机电脑
            responsibility:'',//责任认定
            delisting:'',//是否脱审
            casualties:'',//人员伤害
            assemble:'',//是否拆解
            imgUrls:[],//显示的图片列表
          
        },

        insurance:{
            insureCompany:'',// 保险公司
            insureFiliale:'',// 保险分公司
            insureBranch:'',// 分支机构
            surveyorName:'', //定损员姓名
            surveyorPhone:'',//定损员电话
        },
        // 费用信息
        cost:{
            overhaulFee:'',//拆检费
            otherFee:'',//其他费用
            parkingFee:'',//停车费
            salvageFee:'',//施救费
            towingFee:'',//拖车费
        },
                //手续信息
                procedure:{
                    mortgage:'',//是否抵押
                    licencePlate:'',//车牌
                    loan:'',//是否有贷款
                    idCardCopy:'',//身份证复印件
                    organizationCodeCertificate:'',//组织机构代码证是否有
                    purchaseTax:'',//购置税本
                    registrationCertificate:'',//登记证书是否有
                    subrogationReceipt:'',//权益转让书
                    vehicleKey:'',//车钥匙
                    vehicleLicense:'',//行驶证
                },
      },
      //报价
      quoteForm:{
        bidNickName:'',
        bidUserId:'',
        finalPrice:'',
        submitPrice:'',
        submitPriceIn:'', //内部提交报价
        remark:'',
      },
      blnSubmit:true,
      quoteList:[],
    }
    
  },
  methods:{

    //给字符串中的链接用span标签包裹起来，实现点击跳转
    translateHtml (msg) {
        if (msg === null || msg === undefined || msg === ''){
            return msg;
        }
        var reg =/((http|https):\/\/[-A-Za-z0-9+&@#()/%?=~_|!:,.;]+[-A-Za-z0-9+&@#()/%=~_|])/g
        var textR = msg.replace(
        reg,
        `<span style='color:#2660f5;text-decoration:underline;' onclick=getDownLoad('$1')>$1</span>`
        )
        return textR
    },
    /**
     * 同步价格
     */
    handleSyncSubmitPrice(){
        this.quoteForm.submitPriceIn=this.quoteForm.submitPrice;
        
    },
    /***
     * 
     */
    handleEvaluateTabClick(tab, event){
        
        const index=tab.index;
        this.radioCondition="normal"
        this.evaluatePrice=this.dataForm.evaluate[index].normal;
        
        
    },

    //切换 车况
    handleChangeCondition(value,param){
        
        if (value=="good"){
            
            this.evaluatePrice=param.good;
        }

        if(value=="normal"){
            this.evaluatePrice=param.normal;
            
        }
        if(value=="excelent"){
            this.evaluatePrice=param.excellent;
            
            console.log(param.excellent);
        }

    },
     //显示素材详情
    handleGetDetail(caseId){
      // 获取详情
      getCase(caseId)
      .then(res=>{
          this.dataForm=res.data;
          this.dataForm.damage.imgUrls=JSON.parse(this.dataForm.damage.imgUrls)
      })
      .catch(error=>{

      })
    },

    // 显示报价列表
    handleGetQuoteList(caseId){
   
      getQuoteList(caseId)
      .then(res=>{
        this.quoteList=res.data;
      })
      .catch(error=>{

      })
    },

    //
    handleGetUserDetail(){
        getUserProfile().then(res=>{
            
            this.quoteForm.bidUserId=res.data.id;
            this.quoteForm.bidNickName=res.data.nickName;
            this.quoteForm.finalPrice=0;
            this.blnSubmit=false;
        })
        .catch(error=>{

        })
    },

    onRowClick(row){
        //   this.quoteForm=Object.assign({},row);
        this.quoteForm.caseId=row.caseId;
        this.quoteForm.bidUserId=row.bidUserId;
        this.quoteForm.finalPrice=row.finalPrice;
        this.quoteForm.bidNickName=row.bidNickName;
        this.quoteForm.submitPrice=row.finalPrice;
        this.quoteForm.submitPriceIn=row.finalPrice;
        this.blnSubmit=false;
    },

    //提交报价
    handleSubmit(){
        /**
         * 提交信息为，报价人，报价人id，报价金额
        */
        this.quoteForm.caseId=this.caseId;
       if(this.quoteForm.caseId==undefined ){
            this.$message.error("请选择要提交的报价人")
            return;
       }
       if(this.quoteForm.submitPrice==""){
            this.$message.error("请输入报价")
            return;
       }

       var params=this.quoteForm;
       
      
        submitBid(params)
        .then(res=>{
            this.$message.success("提交成功");
            this.handleClose();    
        })
        .catch(error=>{

        })
     
       
        
    },

    handleClose() {
        const obj = { path: "/vehicle-insure/list" };
        this.$tab.closeOpenPage(obj);
    },

  }, 
}
</script>


<style lang="scss" scoped>

.text-disabled{
    -webkit-text-fill-color: #000502 !important; //修改输入框文字颜色
    // font-size: large;
    // font-weight: bolder;
}
.css-vehicle-modle{
    min-width: 200px;
}
</style>